var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{attrs:{"size":_vm.size,"type":_vm.type,"icon":_vm.icon,"disabled":_vm.disabled,"loading":_vm.isLoading},on:{"click":_vm.openPDF}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }